export const LandingPageVideoContentPTBRTranslations = {
  landingPageVideoSubtitle: 'PLATAFORMA COLABORATIVA PARA TOMADA DE DECISÕES',
  landingPageVideoTitle:
    'Facilitamos para todos, desde executivos até especialistas, trabalhar com dados e previsões impulsionadas por IA que geram ROI',
  landingPageStartVideoTitle: 'Vídeo sobre nossa empresa',
};
